import { useMutation, useQueryClient } from '@tanstack/react-query'
import CareerIntro from 'components/career-intro/career-intro'
import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { startDeeperDive } from 'services/deeper-dive.service'
import { noPreviewImage } from 'utills/image'
import Button from 'components/button/button'
import ContentCard from 'components/card/content-card'
import CardTitle from 'components/card/card-title'

type StartDiveProps = {
  title?: string
  subtitle?: string
  icon_url?: string
  id: string
  description?: string
  isDeepDive?: boolean
  setIsDisplay: React.Dispatch<React.SetStateAction<boolean>>
}

const StartDive: React.FC<StartDiveProps> = ({
  title,
  subtitle,
  icon_url,
  description,
  setIsDisplay,
  isDeepDive,
}) => {
  const queryClient = useQueryClient()
  const location = useLocation()
  const navigate = useNavigate()

  const careerId = location.state?.career_id ?? null

  const startDeeperDiveMutation = useMutation({
    mutationFn: () => startDeeperDive(careerId),
    retry: 0,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['GetCareerForDeeperDive'] })
      setIsDisplay(true)
    },
    onError: () => {},
  })

  const handleStartDive = () => {
    if (!isDeepDive) {
      startDeeperDiveMutation.mutate()
    } else {
      setIsDisplay(true)
    }
  }

  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex justify-center w-full flex-1">
        <div className="flex flex-col gap-8 max-w-[875px] w-full">
          <CareerIntro
            title={title ?? ''}
            subtitle={subtitle}
            description={description}
            image={icon_url || noPreviewImage}
          />

          <ContentCard
            style={{
              backgroundImage:
                "linear-gradient(135deg, #F3EFE5 0%, rgba(243,239,229,0.85) 25%, rgba(243,239,229,0.35) 50%, rgba(243,239,229,0) 70%), url('/assets/svg/DeeperDive.svg')",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'top right',
              backgroundSize: 'cover',
            }}
          >
            <CardTitle
              title="Dive a little deeper"
              subtitle="Learn more about this career's purpose in the world, day in the life, education requirements, and more!"
              subtitleClassName="w-[350px] h-10"
            />
          </ContentCard>
        </div>
      </div>

      <div className="flex justify-between items-center mt-auto pt-4 pb-4">
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Back
        </Button>
        <Button variant="primary" onClick={handleStartDive}>
          {isDeepDive ? 'Continue Deeper Dive' : 'Start Deeper Dive'}
        </Button>
      </div>
    </div>
  )
}

export default StartDive
